import { v4 } from 'uuid'

export const Operator = {
  EQ: 'eq',
  NE: 'ne',
  CO: 'co',
  SW: 'sw',
  EW: 'ew',
  PR: 'pr',
  GT: 'gt',
  GE: 'ge',
  LT: 'lt',
  LE: 'le'
}

export const newCondition = () => {
  return {
    id: v4(),
    filters: [newFilter()]
  }
}

export const newFilter = () => {
  return {
    leftComparator: undefined,
    operator: Operator.EQ,
    rightComparator: undefined
  }
}
